export default "__VITE_ASSET__DJIlHBIf__"